<template>
  <vueper-slides
    ref="myVueperSlides"
    autoplay
    :pause-on-hover="pauseOnHover"
    @autoplay-pause="internalAutoPlaying = false"
    @autoplay-resume="internalAutoPlaying = true"
    :slide-ratio="1 / 4"
  >
    <vueper-slide
      v-for="slide in slides"
      :key="slide.id"
      :title="slide.title"
      :image="slide.image"
      :style="`color: #fff;`"
    />

    <!-- <template #pause>
      <i class="icon pause_circle_outline"></i>
    </template> -->
  </vueper-slides>
</template>

<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

export default {
  components: { VueperSlides, VueperSlide },
  data: () => ({
    pauseOnHover: true,
    autoPlaying: true,
    internalAutoPlaying: true,
    slides: [],
  }),
  methods: {
    updateCarosal(data) {
      this.slides = data;
    },
  },
};
</script>
